// notificationsStore.js
import { create } from "zustand";

export const useNotifications = create((set) => ({
  items: [],
  add: (n) => set((state) => ({ items: [...state.items, n] })),
  remove: (id) =>
    set((state) => ({ items: state.items.filter((x) => x.id !== id) })),
  
  update: (id, patch) =>
    set((state) => ({
      items: state.items.map((x) => (x.id === id ? { ...x, ...patch } : x)),
    })),
}));
